import * as React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import "swiper/css/navigation"
import 'swiper/css/pagination'
// import { Navigation } from "swiper";
import SwiperCore, { Navigation, Pagination } from 'swiper'

SwiperCore.use([Navigation, Pagination]);

const Slider = ({ items }) => {
    return (
        <Swiper className="mySwiper"
            //navigation
                pagination={{ clickable: true }}>
            {items.map((item, index) => (
                <SwiperSlide key={index}>
                    <div>
                        {item.slide}
                        <img src={item.image} alt="" />
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}
export default Slider;